export enum UserPrivileges {
  Coach = 10,
  LeadCoach = 15,
  Admin = 20
}

export const getUserPrivilegeKey = (privileges: number): string => {
  const privilegeMapping: { [key: number]: string } = {
    [UserPrivileges.Coach]: "Coach",
    [UserPrivileges.LeadCoach]: "Lead Coach",
    [UserPrivileges.Admin]: "Admin"
  };

  return privilegeMapping[privileges] || "Unknown";
};
